'use strict'
const env = process.env.NODE_ENV === 'production' ? true : false
//首页

const Index = env ? resolve => require(['@/views/mp/index/Index.vue'], resolve) : require('@/views/mp/index/Index.vue')

//用户
const Users = env ? resolve => require(['@/views/mp/users/Index.vue'], resolve) : require('@/views/mp/users/Index.vue')
//微信
const WxIndex = env ? resolve => require(['@/views/mp/wechat/Index.vue'], resolve) : require('@/views/mp/wechat/Index.vue')
const WxAuth = env ? resolve => require(['@/views/mp/wechat/WxAuth.vue'], resolve) : require('@/views/mp/wechat/WxAuth.vue')
const WxMenu = env ? resolve => require(['@/views/mp/wechat/WxMenu.vue'], resolve) : require('@/views/mp/wechat/WxMenu.vue')
const WxMaterial = env ? resolve => require(['@/views/mp/wechat/WxMaterial.vue'], resolve) : require('@/views/mp/wechat/WxMaterial.vue')
const WxMass = env ? resolve => require(['@/views/mp/wechat/WxMass.vue'], resolve) : require('@/views/mp/wechat/WxMass.vue')
const WxReply = env ? resolve => require(['@/views/mp/wechat/WxReply.vue'], resolve) : require('@/views/mp/wechat/WxReply.vue')
const WxKeyWords = env ? resolve => require(['@/views/mp/wechat/WxKeyWords.vue'], resolve) : require('@/views/mp/wechat/WxKeyWords.vue')
const WxKeyWordsEdit = env ? resolve => require(['@/views/mp/wechat/WxKeyWordsEdit.vue'], resolve) : require('@/views/mp/wechat/WxKeyWordsEdit.vue')
const WxMember = env ? resolve => require(['@/views/mp/wechat/WxMember.vue'], resolve) : require('@/views/mp/wechat/WxMember.vue')
const WxMemberList = env ? resolve => require(['@/views/mp/wechat/WxMemberList.vue'], resolve) : require('@/views/mp/wechat/WxMemberList.vue')
const WxTplMsg = env ? resolve => require(['@/views/mp/wechat/WxTplMsg.vue'], resolve) : require('@/views/mp/wechat/WxTplMsg.vue')
//门店管理
const ShopsManage = env ? resolve => require(['@/views/mp/shops/Index.vue'], resolve) : require('@/views/mp/shops/Index.vue')
const ShopEdit = env ? resolve => require(['@/views/mp/shops/ShopEdit.vue'], resolve) : require('@/views/mp/shops/ShopEdit.vue')
const ClearInfo = env ? resolve => require(['@/views/mp/shops/ClearInfo.vue'], resolve) : require('@/views/mp/shops/ClearInfo.vue')
//收银管理
const PayManage = env ? resolve => require(['@/views/mp/pay_manage/Index.vue'], resolve) : require('@/views/mp/pay_manage/Index.vue')
const PayRecordInfo = env ? resolve => require(['@/views/mp/pay_manage/PayRecordInfo.vue'], resolve) : require('@/views/mp/pay_manage/PayRecordInfo.vue')
const PayCount = env ? resolve => require(['@/views/mp/pay_manage/PayCount.vue'], resolve) : require('@/views/mp/pay_manage/PayCount.vue')
const PayRecord = env ? resolve => require(['@/views/mp/pay_manage/PayRecord.vue'], resolve) : require('@/views/mp/pay_manage/PayRecord.vue')
const ReportList = env ? resolve => require(['@/views/mp/pay_manage/ReportList.vue'], resolve) : require('@/views/mp/pay_manage/ReportList.vue')

//微商城
const VmallIndex = env ? resolve => require(['@/views/mp/vmall/Index.vue'], resolve) : require('@/views/mp/vmall/Index.vue')
const VmallOrderStatistics = env ? resolve => require(['@/views/mp/vmall/OrderStatistics.vue'], resolve) : require('@/views/mp/vmall/OrderStatistics.vue')
const VmallGoods = env ? resolve => require(['@/views/mp/vmall/Goods.vue'], resolve) : require('@/views/mp/vmall/Goods.vue')
const VmallClassify = env ? resolve => require(['@/views/mp/vmall/Classify.vue'], resolve) : require('@/views/mp/vmall/Classify.vue')
const VmallClassifyEdit = env ? resolve => require(['@/views/mp/vmall/ClassifyEdit.vue'], resolve) : require('@/views/mp/vmall/ClassifyEdit.vue')
const VmallBanner = env ? resolve => require(['@/views/mp/vmall/Banner.vue'], resolve) : require('@/views/mp/vmall/Banner.vue')
const VmallBannerEdit = env ? resolve => require(['@/views/mp/vmall/BannerEdit.vue'], resolve) : require('@/views/mp/vmall/BannerEdit.vue')
const VmallGoodsEdit = env ? resolve => require(['@/views/mp/vmall/GoodsEdit.vue'], resolve) : require('@/views/mp/vmall/GoodsEdit.vue')
const VmallOrder = env ? resolve => require(['@/views/mp/vmall/Order.vue'], resolve) : require('@/views/mp/vmall/Order.vue')
const VmallOrderDetail = env ? resolve => require(['@/views/mp/vmall/OrderDetail.vue'], resolve) : require('@/views/mp/vmall/OrderDetail.vue')
const VmallConfigure = env ? resolve => require(['@/views/mp/vmall/Configure.vue'], resolve) : require('@/views/mp/vmall/Configure.vue')
//财务对账
const Finance = env ? resolve => require(['@/views/mp/finance/Index.vue'], resolve) : require('@/views/mp/finance/Index.vue')
const FinanceList = env ? resolve => require(['@/views/mp/finance/List.vue'], resolve) : require('@/views/mp/finance/List.vue')

//会员卡
const Vip = env ? resolve => require(['@/views/mp/vip_card/Index.vue'], resolve) : require('@/views/mp/vip_card/Index.vue')
const VipManage = env ? resolve => require(['@/views/mp/vip_card/VipManage.vue'], resolve) : require('@/views/mp/vip_card/VipManage.vue')
const VipStatistics = env ? resolve => require(['@/views/mp/vip_card/VipStatistics.vue'], resolve) : require('@/views/mp/vip_card/VipStatistics.vue')
const VipMember = env ? resolve => require(['@/views/mp/vip_card/VipMember.vue'], resolve) : require('@/views/mp/vip_card/VipMember.vue')

//营销工具
const Marketing = env ? resolve => require(['@/views/mp/marketing/Index.vue'], resolve) : require('@/views/mp/marketing/Index.vue')

//满减活动
const Promotions = env ? resolve => require(['@/views/mp/marketing/promotions/PromotionsPage.vue'], resolve) : require('@/views/mp/marketing/promotions/PromotionsPage.vue')
const EditPromotions = env ? resolve => require(['@/views/mp/marketing/promotions/PromotionEditPage.vue'], resolve) : require('@/views/mp/marketing/promotions/PromotionEditPage.vue')
const PromotionsInfo = env ? resolve => require(['@/views/mp/marketing/promotions/PromotionInfoPage.vue'], resolve) : require('@/views/mp/marketing/promotions/PromotionInfoPage.vue')
const PromotionsIndex = env ? resolve => require(['@/views/mp/marketing/promotions/Index.vue'], resolve) : require('@/views/mp/marketing/promotions/Index.vue')

//裂变红包
const RedPacketIndex = env ? resolve => require(['@/views/mp/marketing/red_packet/Index.vue'], resolve) : require('@/views/mp/marketing/red_packet/Index.vue')
const RedPacketList = env ? resolve => require(['@/views/mp/marketing/red_packet/RedPacketListPage.vue'], resolve) : require('@/views/mp/marketing/red_packet/RedPacketListPage.vue')
const RedPacketCount = env ? resolve => require(['@/views/mp/marketing/red_packet/RedPacketCountPage.vue'], resolve) : require('@/views/mp/marketing/red_packet/RedPacketCountPage.vue')
const RedPacketRecord = env ? resolve => require(['@/views/mp/marketing/red_packet/RedPacketRecordPage.vue'], resolve) : require('@/views/mp/marketing/red_packet/RedPacketRecordPage.vue')
const RedPacketEdit = env ? resolve => require(['@/views/mp/marketing/red_packet/RedPacketEditPage.vue'], resolve) : require('@/views/mp/marketing/red_packet/RedPacketEditPage.vue')
const RedPacketInfo = env ? resolve => require(['@/views/mp/marketing/red_packet/RedPackInfo.vue'], resolve) : require('@/views/mp/marketing/red_packet/RedPackInfo.vue')
const RedPacketShopListPage = env ? resolve => require(['@/views/mp/marketing/red_packet/RedPacketShopListPage.vue'], resolve) : require('@/views/mp/marketing/red_packet/RedPacketShopListPage.vue')
const RedPacketShopRecordPage = env ? resolve => require(['@/views/mp/marketing/red_packet/RedPacketManagePage.vue'], resolve) : require('@/views/mp/marketing/red_packet/RedPacketManagePage.vue')

//优惠券
const CouponMain = env ? resolve => require(['@/views/mp/marketing/coupon/Main.vue'], resolve) : require('@/views/mp/marketing/coupon/Main.vue')
const CouponList = env ? resolve => require(['@/views/mp/marketing/coupon/List.vue'], resolve) : require('@/views/mp/marketing/coupon/List.vue')
const CouponEdit = env ? resolve => require(['@/views/mp/marketing/coupon/Edit.vue'], resolve) : require('@/views/mp/marketing/coupon/Edit.vue')
const CouponStatistics = env ? resolve => require(['@/views/mp/marketing/coupon/Statistics.vue'], resolve) : require('@/views/mp/marketing/coupon/Statistics.vue')

//结算
const Clear = env ? resolve => require(['@/views/mp/clear/Index.vue'], resolve) : require('@/views/mp/clear/Index.vue')
const ClearList = env ? resolve => require(['@/views/mp/clear/ClearList.vue'], resolve) : require('@/views/mp/clear/ClearList.vue')

const routers = [{
		name: 'index',
		path: 'index',
		meta: {
			active: 'index'
		},
		component: Index
	},
	{
		name: 'users',
		path: 'users',
		meta: {
			active: 'users'
		},
		component: Users
	},
	{
		name: 'wxIndex',
		path: 'wxIndex',
		meta: {
			active: 'wechat'
		},
		component: WxIndex
	},
	{
		name: 'marketing',
		path: 'marketing',
		meta: {
			active: 'marketing'
		},
		component: Marketing
	},
	{
		name: 'promotions',
		path: 'promotions',
		meta: {
			active: 'marketing'
		},
		component: PromotionsIndex,
		children: [{
			name: 'promotionList',
			path: 'promotionList',
			meta: {
				active: 'marketing'
			},
			component: Promotions
		}]
	},
	{
		name: 'editPromotions',
		path: 'editPromotions',
		meta: {
			active: 'marketing'
		},
		component: EditPromotions
	},
	{
		name: 'promotionsInfo',
		path: 'promotionsInfo',
		meta: {
			active: 'marketing'
		},
		component: PromotionsInfo
	},
	{
		name: 'redPacket',
		path: 'redPacket',
		meta: {
			active: 'marketing'
		},
		component: RedPacketIndex,
		children: [{
				name: 'redPacketList',
				path: 'redPacketList',
				meta: {
					active: 'marketing'
				},
				component: RedPacketList
			},
			{
				name: 'redPacketCount',
				path: 'redPacketCount',
				meta: {
					active: 'marketing'
				},
				component: RedPacketCount
			},
			{
				name: 'redPacketRecord',
				path: 'redPacketRecord',
				meta: {
					active: 'marketing'
				},
				component: RedPacketRecord
			}
		]
	},
	{
		name: 'redPacketEdit',
		path: 'redPacketEdit',
		meta: {
			active: 'marketing'
		},
		component: RedPacketEdit
	},
	{
		name: 'redPacketInfo',
		path: 'redPacketInfo',
		meta: {
			active: 'marketing'
		},
		component: RedPacketInfo
	},
	{
		name: 'redPacketShopListPage',
		path: 'redPacketShopListPage',
		meta: {
			active: 'marketing'
		},
		component: RedPacketShopListPage
	},
	{
		name: 'redPacketShopRecordPage',
		path: 'redPacketShopRecordPage',
		meta: {
			active: 'marketing'
		},
		component: RedPacketShopRecordPage
	},
	{
		name: 'wxAuth',
		path: 'wxAuth',
		meta: {
			active: 'wechat'
		},
		component: WxAuth
	}, {
		name: 'wxMenu',
		path: 'wxMenu',
		meta: {
			active: 'wechat'
		},
		component: WxMenu
	}, {
		name: 'wxMaterial',
		path: 'wxMaterial',
		meta: {
			active: 'wechat'
		},
		component: WxMaterial
	}, {
		name: 'wxMass',
		path: 'wxMass',
		meta: {
			active: 'wechat'
		},
		component: WxMass
	}, {
		name: 'wxReply',
		path: 'wxReply',
		meta: {
			active: 'wechat'
		},
		component: WxReply
	}, {
		name: 'wxKeyWords',
		path: 'wxKeyWords',
		meta: {
			active: 'wechat'
		},
		component: WxKeyWords
	}, {
		name: 'wxKeyWordsEdit',
		path: 'wxKeyWordsEdit',
		meta: {
			active: 'wechat'
		},
		component: WxKeyWordsEdit
	}, {
		name: 'wxMember',
		path: 'wxMember',
		meta: {
			active: 'wechat'
		},
		component: WxMember
	}, {
		name: 'wxMemberList',
		path: 'wxMemberList',
		meta: {
			active: 'wechat'
		},
		component: WxMemberList
	}, {
		name: 'wxTplMsg',
		path: 'wxTplMsg',
		meta: {
			active: 'wechat'
		},
		component: WxTplMsg
	}, {
		name: 'shopsManage',
		path: 'shopsManage',
		meta: {
			active: 'shops'
		},
		component: ShopsManage
	}, {
		name: 'shopEdit',
		path: 'shopEdit',
		meta: {
			active: 'shops'
		},
		component: ShopEdit
	}, {
		name: 'clearInfo',
		path: 'clearInfo',
		meta: {
			active: 'shops'
		},
		component: ClearInfo
	}, {
		name: 'payManage',
		path: 'payManage',
		meta: {
			active: 'pay'
		},
		component: PayManage,
		children: [{
			path: '',
			meta: {
				active: 'pay'
			},
			component: PayCount
		}, {
			name: 'payCount',
			path: 'payCount',
			meta: {
				active: 'pay'
			},
			component: PayCount
		}, {
			name: 'payRecord',
			path: 'payRecord',
			meta: {
				active: 'pay'
			},
			component: PayRecord
		}, {
			name: 'reportList',
			path: 'reportList',
			meta: {
				active: 'pay'
			},
			component: ReportList
		}]
	}, {
		name: 'payRecordInfo',
		path: 'payRecordInfo',
		meta: {
			active: 'pay'
		},
		component: PayRecordInfo
	}, {
		name: 'vmall',
		path: 'vmall',
		meta: {
			active: 'vmall'
		},
		component: VmallIndex,
		children: [{
				path: '',
				meta: {
					active: 'vmall'
				},
				component: VmallOrderStatistics
			}, {
				name: 'statistics',
				path: 'statistics',
				meta: {
					active: 'vmall'
				},
				component: VmallOrderStatistics
			}, {
				name: 'vGoods',
				path: 'vGoods',
				meta: {
					active: 'vmall'
				},
				component: VmallGoods
			}, {
				name: 'classify',
				path: 'classify',
				meta: {
					active: 'vmall'
				},
				component: VmallClassify
			},
			{
				name: 'vBanner',
				path: 'vBanner',
				meta: {
					active: 'vmall'
				},
				component: VmallBanner
			},
			{
				name: 'vOrder',
				path: 'vOrder',
				meta: {
					active: 'vmall'
				},
				component: VmallOrder
			},
			{
				name: 'configure',
				path: 'configure',
				meta: {
					active: 'vmall'
				},
				component: VmallConfigure
			}
		]
	},
	{
		name: 'bannerEdit',
		path: 'bannerEdit',
		meta: {
			active: 'vmall'
		},
		component: VmallBannerEdit
	}, {
		name: 'classifyEdit',
		path: 'classifyEdit',
		meta: {
			active: 'vmall'
		},
		component: VmallClassifyEdit
	}, {
		name: 'vOrderDetail',
		path: 'vOrderDetail',
		meta: {
			active: 'vmall'
		},
		component: VmallOrderDetail
	}, {
		name: 'vGoodsEdit',
		path: 'vGoodsEdit',
		meta: {
			active: 'vmall'
		},
		component: VmallGoodsEdit
	}, {
		name: 'finance',
		path: 'finance',
		meta: {
			active: 'finance'
		},
		component: Finance,
		children: [{
				path: '',
				meta: {
					active: 'finance'
				},
				component: FinanceList
			},
			{
				name: 'financeList',
				path: 'list',
				meta: {
					active: 'finance'
				},
				component: FinanceList
			},
		]
	}, {
		name: 'vip',
		path: 'vip',
		meta: {
			active: 'vip'
		},
		component: Vip,
		children: [{
				path: '',
				meta: {
					active: 'vip'
				},
				component: VipManage
			},
			{
				name: 'vipManage',
				path: 'manage',
				meta: {
					active: 'vip'
				},
				component: VipManage
			},
			{
				name: 'vipStatistics',
				path: 'statistics',
				meta: {
					active: 'vip'
				},
				component: VipStatistics
			},
			{
				name: 'vipMember',
				path: 'member',
				meta: {
					active: 'vip'
				},
				component: VipMember
			},
		]
	}, {
		name: 'coupon',
		path: 'coupon',
		meta: {
			active: 'marketing'
		},
		component: CouponMain,
		children: [{
				path: '',
				meta: {
					active: 'marketing'
				},
				component: CouponList
			},
			{
				name: 'couponList',
				path: 'list',
				meta: {
					active: 'marketing'
				},
				component: CouponList
			},
			{
				name: 'couponStatistics',
				path: 'statistics',
				meta: {
					active: 'marketing'
				},
				component: CouponStatistics
			}
		]
	},
	{
		name: 'couponEdit',
		path: 'couponEdit',
		meta: {
			active: 'marketing'
		},
		component: CouponEdit
	},
	
	{
		name: 'clear',
		path: 'clear',
		meta: {
			active: 'clear'
		},
		component: Clear,
		children: [{
				path: '',
				meta: {
					active: 'clear'
				},
				component: ClearList
			},
			{
				name: 'clearList',
				path: 'clearList',
				meta: {
					active: 'clear'
				},
				component: ClearList
			},
		]
	}, 
]

export default routers


// WEBPACK FOOTER //
// ./src/router/mp.js